import EyeClosedIcon from '@assets/icons/eye-closed.svg';
import EyeOpenIcon from '@assets/icons/eye-open.svg';
import React from 'react';
import { Pressable } from 'react-native';
import { useConfidentialFieldToggle } from '@/experiences/sales-portal/domain/ordering/blocs/hooks/use-confidential-field-toggle';
import { useTheme } from '@/contexts/theme-context';

const ICON_SIZE = 24;

/**
 * Eye-icon toggle for hiding/showing confidential sales-rep data.
 *
 * Self-subscribes to the visibility store so a toggle press only re-renders
 * this component, not the parent screen.
 */
export const ConfidentialFieldToggle: React.FC = () => {
  const theme = useTheme();
  const { accessibilityLabel, isVisible, onToggle } =
    useConfidentialFieldToggle();

  const iconColor = isVisible
    ? theme.sk.color.icon.primary
    : theme.sk.color.icon.secondary;

  const Icon = isVisible ? EyeOpenIcon : EyeClosedIcon;

  return (
    <Pressable
      accessibilityLabel={accessibilityLabel}
      accessibilityRole="button"
      onPress={onToggle}
    >
      <Icon color={iconColor} height={ICON_SIZE} width={ICON_SIZE} />
    </Pressable>
  );
};
